
export const terms = (state) => {
  return state.filters
}

export const checkPump = (state) => (pump) => {
  return state.filters.pumps.filter(p => p.key === pump)
}

export const termsError = (state) => {
  return state.error
}

export const termsType = (state) => (type) => {
  if (state.filters[type] !== undefined) {
    return state.filters[type]
  }
  return []
}

export const termsItem = (state) => (type, key, lang) => {
  const label = `name_${lang}`
  const filters = state.filters[type]
  return filters.filter(f => f.key === key)[0][label]
}
